<template>
  <div class="footer-container" :style="{'--primary-color': settings.primaryColor ? settings.primaryColor.hex : '', '--secondary-color': settings.secondaryColor ? settings.secondaryColor.hex : ''}" v-if="!isHany">
    <div class="container-fluid">
      <div>
        <p><Translate directive="footer.poweredby" /></p>
        <a href="http://www.plankk.com" target="_blank"
          ><img src="../../assets/plankk.png" width="188" height="58" alt="Plankk Fitness Apps"
        /></a>
      </div>
      <ul class="social-media">
        <li v-if="settings.instagramUrl">
          <a :href="settings.instagramUrl" class="link" target="_blank" aria-label="instagram url"
            ><font-awesome-icon class="icon" :icon="['fab', 'instagram']" size="lg" />
          </a>
        </li>
        <li v-if="settings.facebookUrl">
          <a :href="settings.facebookUrl" class="link" target="_blank" aria-label="facebook url"
            ><font-awesome-icon class="icon" :icon="['fab', 'facebook']" size="lg" />
          </a>
        </li>
        <li v-if="settings.twitterUrl">
          <a :href="settings.twitterUrl" class="link" target="_blank" aria-label="twitter url"
            ><font-awesome-icon class="icon" :icon="['fab', 'twitter']" size="lg" />
          </a>
        </li>
        <li v-if="settings.youtubeUrl">
          <a :href="settings.youtubeUrl" class="link" target="_blank" aria-label="youtube url"
            ><font-awesome-icon class="icon" :icon="['fab', 'youtube']" size="lg" />
          </a>
        </li>
      </ul>
      <p>{{settings.siteName}} Fitness App <span><Translate directive="footer.partnership" /></span>
         <a href="https:www.plankk.com" class="link" target="_blank">Plankk</a>
         <span> <Translate directive="footer.and" /></span> {{ trainerName }}.
         <br>© Copyright Plankk. <span> <Translate directive="footer.copyright" /></span>
         <router-link class="link" to="/privacy"><Translate directive="footer.privacy" /></router-link> |
         <router-link class="link" to="/tos"><Translate directive="footer.terms" /></router-link>
         <br><span> <Translate directive="footer.questions" /> </span>{{settings.siteName}}? <span> <Translate directive="footer.reachout" /> </span>
         <a v-if="settings.supportEmail" :href="settings.supportEmail" target="_blank" class="link">{{settings.supportEmail.replace('mailto:', '')}}</a>
         <a v-else :href="this.$_polyglot.t('footer.support.email')" target="_blank" class="link"><Translate directive="footer.support" /></a>
      </p>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Translate from './translate'
export default {
  components: {
    Translate
  },
  computed: {
    trainerName () {
      return process.env.VUE_APP_TRAINER_NAME
    },
    isHany () {
      return process.env.VUE_APP_TRAINER_ID === '612cea59b5c5dd0bd0ac4157'
    },
    ...mapState(['home', 'settings'])
  }
}
</script>

<style scoped lang="scss">
.footer-container {
  padding: 40px;
  background-color: var(--secondary-color);
  color: #fff;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.container-fluid {
  font-family: 'Montserrat', sans-serif;
  font-weight: 400;
  text-align: -webkit-center;
  -webkit-font-smoothing: antialiased;
  margin: auto;
  padding-left: 15px;
  padding-right: 15px;
  align-items: center;
  .link {
    cursor: pointer;
    color: white;
    text-decoration: none;
    &:hover {
      opacity: 0.5;
      }
  }
}
p {
  margin: 0;
  font-size: 0.75em;
}
.social-media {
  display: inline-block;
  margin: 0px;
  padding: 0px;
  li {
  list-style-type: none;
  float: left;
  margin-right: 10px;
  }
}

</style>
